/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

import {
  convertedScribeSDKValue,
  GrabXDataTypes,
  getFeature,
  initializeScribeSDK,
  convertData,
} from "grabx"
import { get } from "lodash"
import { storageHelper } from "utils/storage"

// list of grabX variable to be pulled
export const MEX_PORTAL_FEATURE_FLAG = [
  {
    grabxVariableName: "whitelistMenuTroyPortalV2",
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
    key: "hasAccessMenu",
  },
  {
    grabxVariableName: "whitelistInventoryTroyPortalV2",
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
    key: "hasAccessInventory",
  },
  {
    grabxVariableName: "whitelistOrderManagerTroyPortalV2",
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
    key: "hasAccessOrderManager",
  },
  {
    grabxVariableName: "mexPortalEnableLocationsTab",
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
    key: "hasAccessLocations",
  },
]

export const buildFeatureFlags = (
  results: PromiseSettledResult<convertedScribeSDKValue>[],
): Record<string, any> => {
  const featureFlags: Record<string, any> = {}

  MEX_PORTAL_FEATURE_FLAG.forEach((flag, index) => {
    if (flag.grabxVariableName === "") {
      return
    }

    const data: convertedScribeSDKValue = {
      variable_name: get(results[index], ["value", "variable_name"]),
      feature_value: get(results[index], ["value", "feature_value"]),
      feature_value_json: get(results[index], ["value", "feature_value_json"]),
      error: get(results[index], ["value", "error"]),
    }

    if (flag.key) {
      featureFlags[flag.key] = convertData(
        data,
        flag.dataType,
        flag.defaultValue,
      )
    }
  })

  // whitelistFeedbackTroyPortalV2 was rolled out True@100% across all 8 Grab
  // operating countries plus the merchant group, so feedback access is
  // universal. The GrabX flag has been removed; hardcode the stored key that
  // the sidebar reads via haveAccessToFeature("hasAccessFeedback").
  featureFlags.hasAccessFeedback = true

  return featureFlags
}

export const setupMexPortalFeatureFlag = async () => {
  try {
    initializeScribeSDK()

    if (!MEX_PORTAL_FEATURE_FLAG.length) {
      return
    }

    const promises = MEX_PORTAL_FEATURE_FLAG.map(grabxFlag => {
      return getFeature(grabxFlag.grabxVariableName, grabxFlag.dataType)
    })

    const results = await Promise.allSettled(promises)
    const featureFlags = buildFeatureFlags(results)
    storageHelper.setMexPortalFeatureFlags(featureFlags)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error setting up feature flags:", error)
  }
}
